import { MAIN_URL } from "./ServiceConstants";
import axios from "axios";

async function getPatientList() {
  return axios.post(MAIN_URL + "/OrthoMagic/GetPortalPatientList", {});
}

async function getPatientDetail(patientId) {
  const dataObject = {
    Action: "S",
    Id: patientId,
  };

  const url = MAIN_URL + "/OrthoMagic/SetPortalPatient";
  return axios.post(url, { dataObject });
}

async function getPatientActionHistory(patientId) {
  const dataObject = {
    Action: "S",
    Id: patientId,
  };
  const url = MAIN_URL + "/OrthoMagic/GetPortalActionDetails";
  return axios.post(url, { dataObject });
}

function requestAligners(patientId, note) {
  const url = MAIN_URL + "/OrthoMagic/SetPortalAlignerRequest";
  const dataObject = {
    PatientId: patientId,
    Note: note,
  };

  return axios.post(url, { dataObject });
}

function sendMessageForPatient(patientId, message) {
  const url = MAIN_URL + "/OrthoMagic/AddComment";
  const dataObject = {
    CommunicationRequest: {
      PatientId: patientId,
      Note: message,
      imgs: [],
    },
  };

  return axios.post(url, { dataObject });
}

function archievePatient(patientId, addToArsiv) {
  let actionType = 0;
  if (addToArsiv == true) actionType = 5;

  const url = MAIN_URL + "/OrthoMagic/SetPortalClientState";
  const dataObject = {
    PatientId: patientId,
    Arsiv: actionType,
  };

  return axios.post(url, { dataObject });
}

function setFavourite(patientId, favourite) {
  const url = MAIN_URL + "/OrthoMagic/SetPortalClientState";
  const dataObject = {
    PatientId: patientId,
    Favori: favourite,
  };

  return axios.post(url, { dataObject });
}

function getMessages(patientId, page) {
  const url = MAIN_URL + "/OrthoMagic/GetComments";
  const dataObject = {
    CommunicationRequest: {
      PatientId: patientId,
      Page: page,
    },
  };

  return axios.post(url, { dataObject });
}

function getImageSet(cargoId) {
  const dataObject = { Action: "S", CargoId: cargoId };
  return axios.post(MAIN_URL + "/OrthoMagic/SetPortalImgSet", { dataObject });
}

function downloadFile(fileUrl, downloadCallback) {
  return axios({
    url: fileUrl, //your url
    method: "GET",
    responseType: "blob",
    onDownloadProgress: (progressEvent) => {
      let total = progressEvent.event.srcElement.getResponseHeader('ContentLength') || 15000000
      let pr = Math.floor(progressEvent.loaded / total * 100)
      downloadCallback(pr);
    },
  })
}

function sendToRevision(actionId, note) {
  const url = MAIN_URL + "/OrthoMagic/SetPortalFlowAction";
  return axios.post(url, {
    dataobject: {
      ActionId: actionId,
      ActionNextStepId: 5,
      Note: note,
    },
  });
}

function approvePlan(actionId, note) {
  const url = MAIN_URL + "/OrthoMagic/SetPortalFlowAction";
  return axios.post(url, {
    dataobject: {
      ActionId: actionId,
      ActionNextStepId: 9,
      Note: note,
    },
  });
}

function getPlanDetail(planId) {
  return axios.post(MAIN_URL + "/OrthoMagic/GetPortalPlanDetails", {
    dataobject: { Id: planId },
  });
}

async function addNewPatient(patientDetails) {
  return axios.post(MAIN_URL + "/OrthoMagic/SetPortalPatient", {
    dataobject: {
      Action: "I",
      Id: 0,
      ...patientDetails,
    },
  });
}

async function insertImageMetaData(
  patientId,
  treatmentNote,
  contentType,
  resultImages
) {
  return axios.post(MAIN_URL + "/OrthoMagic/SetPortalImgSet", {
    dataobject: {
      Action: "I",
      Id: 0,
      PatientId: patientId,
      Note: treatmentNote,
      Content: contentType,
      ...resultImages,
    },
  });
}

async function uploadImages(images, progressCallback) {
  // TODO: currently request interceptor disabled since it changes content-type
  // find a way to handle this inside interceptor. Do not change content-type for this request
  const userSession = sessionStorage.getItem("user");
  const user = JSON.parse(userSession);
  const UserId = user.UserId;
  const SessionGUID = user.SessionGUID;
  var sequence = sessionStorage.getItem("sequence", "0");
  sequence = Number(sequence) + 1;
  sessionStorage.setItem("sequence", sequence);
  const url =
    MAIN_URL +
    "/OrthoMagic/FileUpload?GUID=" +
    SessionGUID +
    "&UserId=" +
    UserId +
    "&Sequence=" +
    sequence +
    "&imgtyp=0";
  const formData = new FormData();

  const keys = Object.keys(images);
  var totalSize = 0;
  for (const key of keys) {
    totalSize += images[key].size;
    formData.append("file", images[key]);
  }

  const config = {
    onUploadProgress: (progressEvent) => {
      var pr = (100 * Number(progressEvent.loaded)) / totalSize;
      progressCallback(pr);
    },
  };
  const uninterceptedAxiosInstance = axios.create();
  return uninterceptedAxiosInstance
    .post(url, formData, config)
    .then((data) => data.data)
    .then((data) => {
      console.log(data);
      var response = {};
      for (var i = 0; i < keys.length; i++) {
        response[keys[i]] = data[i].Name;
      }
      return response;
    });
}

const PatientService = {
  getPatientList,
  getPatientDetail,
  getPatientActionHistory,
  requestAligners,
  sendMessageForPatient,
  archievePatient,
  setFavourite,
  getMessages,
  getImageSet,
  downloadFile,
  sendToRevision,
  approvePlan,
  getPlanDetail,
  addNewPatient,
  insertImageMetaData,
  uploadImages
};

export default PatientService;
